import React from "react";
import { Button } from "components/Graphs/Button";
import { LaunchableErrorLayout } from "./LaunchableErrorLayout";

interface LaunchableLoadErrorProps {
  retrying?: boolean;
  onRetry?: () => void;
}

export const LaunchableLoadError: React.FC<LaunchableLoadErrorProps> = ({
  retrying,
  onRetry,
}) => (
  <LaunchableErrorLayout
    title="Unable to Load Launchable"
    description="Something went wrong while loading this launchable. Please try again."
    action={
      onRetry ? (
        <Button
          type="button"
          onClick={onRetry}
          isLoading={retrying}
          loadingText="Retrying"
        >
          Try again
        </Button>
      ) : undefined
    }
  />
);
